import React from 'react'
import Spinner from './Spinner'

const Button = (props) => {
    const { text, variant, pending, disabled, ...rest } = props
    let clazzName = ''
    switch (variant) {
        case 'green':
            clazzName = 'bg-green-700 hover:bg-green-800 disabled:bg-green-500'
            break;
        case 'blue':
            clazzName = 'bg-blue-800 hover:bg-blue-900 disabled:bg-blue-500'
            break;
        default:
            // clazzName = 'bg-green-700'
            break;
    }

    return (
        <button className={`flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm ${clazzName}`} {...rest} disabled={pending || disabled}>
            {text}
            {pending && <Spinner />}
        </button>
    )
}

export default Button